import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from 'vue';
import { VALIDATION_RULES } from '@/constants/ValidationRules';
import { INPUT_TYPES } from "@/constants/InputTypes";
import SimpleCrud from "@/components/SimpleCrud.vue";
import { USER_ROLES } from "@/constants/UserRoles";
let Instructors = class Instructors extends Vue {
    title = 'Instruktoři';
    storeModule = 'instructor';
    formAddTitle = 'Nový instruktor';
    formEditTitle = 'Upravit instruktora';
    headers = [
        {
            text: 'Jméno',
            value: 'data.name',
            rules: [VALIDATION_RULES.REQUIRED],
            type: INPUT_TYPES.TEXT,
        },
        {
            text: 'Příjmení',
            value: 'data.surname',
            rules: [VALIDATION_RULES.REQUIRED],
            type: INPUT_TYPES.TEXT,
        },
        {
            text: 'Email',
            value: 'data.email',
            rules: [VALIDATION_RULES.REQUIRED],
            type: INPUT_TYPES.EMAIL,
            readOnly: true,
        },
        {
            text: 'Telefonní číslo',
            value: 'data.phone',
            rules: [VALIDATION_RULES.REQUIRED, VALIDATION_RULES.PHONE_NUMBER],
            type: INPUT_TYPES.TEXT,
        },
        {
            text: 'Platová třída',
            value: 'data.grade_id',
            rules: [VALIDATION_RULES.REQUIRED],
            type: INPUT_TYPES.SELECT,
            selectItems: this.grades,
            selectValue: 'id',
            selectText: 'data.title',
            visibleFromRole: 100,
        },
        {
            text: 'Role',
            value: 'data.role',
            rules: [VALIDATION_RULES.REQUIRED],
            type: INPUT_TYPES.SELECT,
            selectItems: USER_ROLES,
            selectValue: 'id',
            selectText: 'title',
            editableFromRole: 100,
        },
        {
            text: 'Odvádí daň',
            value: 'data.paysTaxes',
            rules: [],
            type: INPUT_TYPES.SELECT,
            selectItems: [
                {
                    val: false,
                    title: 'Ne',
                },
                {
                    val: true,
                    title: 'Ano'
                },
            ],
            selectValue: 'val',
            selectText: 'title',
            editableFromRole: 100,
        },
        {
            text: 'Skills',
            value: 'data.skills',
            rules: [],
            type: INPUT_TYPES.MULTIPLE_SELECT,
            selectItems: [
                {
                    val: 'kid-school-junior',
                    title: 'Dětská školka - Junior',
                },
                {
                    val: 'kid-school-medior',
                    title: 'Dětská školka - Medior',
                },
                {
                    val: 'kid-school-senior',
                    title: 'Dětská školka - Senior',
                },
                {
                    val: 'ski-junior',
                    title: 'Lyže - Junior',
                },
                {
                    val: 'ski-medior',
                    title: 'Lyže - Medior',
                },
                {
                    val: 'ski-senior',
                    title: 'Lyže - Senior',
                },
                {
                    val: 'snb-junior',
                    title: 'Snowboard - Junior',
                },
                {
                    val: 'snb-medior',
                    title: 'Snowboard - Medior',
                },
                {
                    val: 'snb-senior',
                    title: 'Snowboard - Senior',
                },
                {
                    val: 'wex-junior',
                    title: 'WEX - Junior',
                },
                {
                    val: 'wex-medior',
                    title: 'WEX - Medior',
                },
                {
                    val: 'wex-senior',
                    title: 'WEX - Senior',
                },
            ],
            selectValue: 'val',
            selectText: 'title',
            editableFromRole: 100,
        },
        {
            text: '',
            value: 'actions',
            rules: [],
            type: '',
            sortable: false,
            notEditable: true,
            visibleFromRole: 100,
        },
    ];
    defaultItem = {
        id: 'new-instructor',
        data: {
            name: '',
            surname: '',
            email: '',
            phone: null,
            grade_id: null,
            role: 0,
            image: null,
            balance: 0,
            notifications: [
                'app.info',
                'app.alert',
                'app.critical',
                'email.critical',
            ],
            paysTaxes: false,
        },
    };
    get isAdmin() {
        return this.$store.getters['user/isAdmin'];
    }
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    get grades() {
        return this.$store.getters['grade/active'];
    }
};
Instructors = __decorate([
    Component({
        components: {
            SimpleCrud
        }
    })
], Instructors);
export default Instructors;
